module.exports = __webpack_public_path__ + "static/media/EVERGREEN.1ee39eee.svg";